import {
  ReportDashboardComponentKind,
  ReportDashboardComponentViewMode,
  VisualizationType,
  type ReportDashboardComponentViewData,
} from '@core/reports-types';

export const getComponentVisualizationType = (
  component: ReportDashboardComponentViewData,
): VisualizationType => {
  switch (component.viewMode) {
    case ReportDashboardComponentViewMode.Chart: {
      return VisualizationType.Chart;
    }
    case ReportDashboardComponentViewMode.Summary: {
      return VisualizationType.Summary;
    }
    case ReportDashboardComponentViewMode.Table: {
      if (component.kind === ReportDashboardComponentKind.Breakdown && component.secondaryGroup) {
        return VisualizationType.PivotTable;
      }
      if (component.kind === ReportDashboardComponentKind.Trend && component.primaryGroup) {
        return VisualizationType.PivotTable;
      }
      return VisualizationType.Table;
    }
    default: {
      throw new Error('Unknown view mode:', component.viewMode);
    }
  }
};
